var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 48,
    viewBox: "0 0 70 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 47,
    rx: 5.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 24,
    r: 17,
    fill: "#6179EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9536 13.8008L34.8184 14.2601V27.5886L34.9536 27.7235L41.1404 24.0665L34.9536 13.8008Z",
    fill: "#BFCAF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9536 13.8008L28.7666 24.0665L34.9536 27.7235V21.2543V13.8008Z",
    fill: "#FFFEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9537 28.8954L34.8774 28.9884V33.7362L34.9537 33.9587L41.1443 25.2402L34.9537 28.8954Z",
    fill: "#C0CAF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9536 33.9587V28.8954L28.7666 25.2402L34.9536 33.9587Z",
    fill: "#FFFEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9536 27.7232L41.1404 24.0661L34.9536 21.2539V27.7232Z",
    fill: "#7F93EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7666 24.0661L34.9536 27.7232V21.2539L28.7666 24.0661Z",
    fill: "#BFCAF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtn);
export default __webpack_public_path__ + "static/media/etn.c5611ff7dd801cf65c2643852f9274e0.svg";
export { ForwardRef as ReactComponent };